import { useCallback, useEffect, useState } from 'react';
import { GoogleCalendarService, GoogleCalendarStatus } from '../services/google-calendar.service';

/// Se a agenda do usuário está conectada ao Google; sem app ou com falha, age como desconectada.
export const useGoogleCalendar = () => {
    const [status, setStatus] = useState<GoogleCalendarStatus | null>(null);

    const reload = useCallback(() => {
        new GoogleCalendarService()
            .status()
            .then((res) => setStatus(res.data.data ?? null))
            .catch(() => setStatus(null));
    }, []);

    useEffect(reload, [reload]);

    const usable = !!status?.available && status.connected && !status.expired;

    return { status, usable, reload };
};
